// extracted by mini-css-extract-plugin
module.exports = {"container":"SplashScreen_container__jbrwa","fadeOut":"SplashScreen_fadeOut__BD5sz","video_wrapper":"SplashScreen_video_wrapper__w_Ta4","video":"SplashScreen_video__yvZXi"};